import api from './client';

export const checkinAPI = {
  // Submit/upsert today's check-in
  submit: (data: {
    mood: string;
    energyLevel?: number;
    notes?: string | null;
    subspaceDepth?: number;
    dropSymptoms?: string[];
    recoveryStatus?: string | null;
    hoursSinceScene?: number | null;
    sharedWithDominant?: boolean;
    visibility?: 'private' | 'partners' | 'hierarchy';
  }) => api.post('/checkins', data),

  // Get today's check-in
  getToday: () => api.get('/checkins/today'),

  // Get own check-in history
  getHistory: (days = 30) => api.get('/checkins/history', { params: { days } }),

  // Get partner's check-in history (Dom only)
  getPartnerHistory: (userId: string | number, days = 30) =>
    api.get(`/checkins/partner/${userId}`, { params: { days } }),

  // Get mood trends (date + mood + energy for chart)
  getTrends: (days = 14) => api.get('/checkins/trends', { params: { days } }),

  // Get aggregated stats (total, distribution, avg energy, streaks)
  getStats: (days = 30) => api.get('/checkins/stats', { params: { days } }),
};
